
export function showConfetti() {
  const confettiCount = 150;
  const colors = ['#f44336', '#e91e63', '#9c27b0', '#673ab7', '#3f51b5', '#2196f3', '#03a9f4', '#00bcd4'];
  
  // Create container for confetti
  const container = document.createElement('div');
  container.style.position = 'fixed';
  container.style.top = '0';
  container.style.left = '0';
  container.style.width = '100%';
  container.style.height = '100%';
  container.style.pointerEvents = 'none';
  container.style.zIndex = '9999';
  document.body.appendChild(container);
  
  // Create and animate confetti pieces
  for (let i = 0; i < confettiCount; i++) {
    const confetti = document.createElement('div');
    const size = Math.random() * 10 + 5; // 5-15px size
    
    confetti.style.position = 'absolute';
    confetti.style.width = `${size}px`;
    confetti.style.height = `${size}px`;
    confetti.style.backgroundColor = colors[Math.floor(Math.random() * colors.length)];
    confetti.style.borderRadius = Math.random() > 0.5 ? '50%' : '0'; // Circles and squares
    confetti.style.top = '0';
    confetti.style.left = `${Math.random() * 100}%`;
    container.appendChild(confetti);
    
    // Set animation properties
    confetti.style.transform = 'translateY(0)';
    confetti.style.opacity = '1';
    
    // Apply animation
    const duration = Math.random() * 3 + 3; // 3-6s duration
    const rotation = Math.random() * 360;
    const finalY = window.innerHeight;
    
    confetti.animate(
      [
        { transform: `translateY(0) rotate(0deg)`, opacity: 1 },
        { transform: `translateY(${finalY}px) rotate(${rotation}deg)`, opacity: 0 }
      ],
      {
        duration: duration * 1000,
        easing: 'cubic-bezier(.215,.61,.355,1)'
      }
    );
    
    // Remove after animation finishes
    setTimeout(() => {
      confetti.remove();
    }, duration * 1000);
  }
  
  // Remove container after all animations finished
  setTimeout(() => {
    container.remove();
  }, 8000);
}
